import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

const IDS = { DMI_LABEL: 'footerMessages.dmiLabel' };

const enMessages = { [IDS.DMI_LABEL]: 'Dovenmuehle Mortgage, Inc.' };

const enMurabahaMessages = {
  ...enMessages,
  [IDS.DMI_LABEL]: 'DMI',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
